import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback
} from "react";
import styled from "styled-components";
import { WidgetContext } from "../WidgetContext";
import css from "classnames";
import NotificationIcon from "./NotificationIcon";
import Close from "./Close";

const CloseButton = styled(Close)`
  cursor: pointer;
  flex: 0 0 30px;
  height: 30px;
  margin-left: 10px;
  width: 30px;
`;

export default styled(({ className, ...rest }: any) => {
  const timer = useRef<any>();
  const animation = useRef<any>();
  const [isOpen, setIsOpen] = useState(false);
  const { state, dispatch } = useContext(WidgetContext);
  const close = useCallback(() => {
    setIsOpen(false);
    animation.current = setTimeout(
      () => dispatch({ type: "set", value: { toast: null } }),
      250
    );
  }, [dispatch]);

  useEffect(() => {
    if (state.toast) {
      clearTimeout(animation.current);
      setIsOpen(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(close, 7500);
    }
  }, [state.toast, dispatch, close]);

  return (
    <div
      className={css("tecobi-notification", { open: isOpen }, className)}
      {...rest}
    >
      <NotificationIcon color={state.config.smswidgetconfig.background_color} />
      <span>{state.toast}</span>
      <CloseButton
        color={state.config.smswidgetconfig.background_color}
        onClick={close}
      />
    </div>
  );
})`
  align-items: center;
  background-color: white;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  position: absolute;
  top: 40px;
  right: 10px;
  left: 10px;
  min-height: 50px;
  opacity: 0;
  visibility: hidden;
  padding: 15px;
  pointer-events: none;
  transition: all linear 0.2s;
  z-index: 100;

  .notification-icon {
    height: 30px;
    width: 30px;
    flex: 0 0 30px;
    margin-right: 10px;
  }

  span {
    flex: 1 1 auto;
  }

  &.open {
    visibility: visible;
    pointer-events: initial;
    opacity: 1;
  }
`;
